/*
 * @Description:
 * @Author: shenkaiyao
 * @Date: 2020-12-09 09:49:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-10 15:18:51
 */
import VehicleInfo from './vehicleInfo';

export default VehicleInfo